'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import { EntityTypes, getContactsStatus } from 'AdsUI/lib/Constants';
import ReportingCampaignRecord from 'AdsUI/records/reporting/ReportingCampaignRecord';
import CampaignListDataRecord from 'AdsUI/records/reporting/CampaignListDataRecord';
import ReportingDataRecord from 'AdsUI/records/reporting/ReportingDataRecord';
import ReportRecord from 'AdsUI/records/reporting/ReportRecord';
import TrackingStatusParser from 'AdsUI/lib/TrackingStatusParser';
import { fromGlobalFilters } from 'AdsUI/records/reporting/CampaignListFilterRecord';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload
  } = action;
  const {
    filters
  } = payload || {};

  switch (type) {
    case Actions.CAMPAIGN_LIST_FETCH_SUCCEEDED:
      {
        const now = window.performance.now();

        if (!payload) {
          return state;
        }

        const {
          reports,
          totals
        } = payload;
        const campaigns = reports.map(campaign => ({
          entity: new ReportingCampaignRecord(campaign.entity),
          report: new ReportRecord(campaign.report),
          trackingStatus: TrackingStatusParser.parse(campaign.trackingStatus)
        }));
        const existingListData = state.get(filters);
        const campaignsList = List(campaigns.map(campaign => ReportingDataRecord(campaign)));
        const campaignListData = CampaignListDataRecord({
          // Maintain same sort
          campaigns: existingListData ? campaignsList.sort((a, b) => {
            const aIndex = existingListData.campaigns.findIndex(reportingRecord => reportingRecord.entity.id === a.entity.id);

            if (aIndex === -1) {
              return 1;
            }

            const bIndex = existingListData.campaigns.findIndex(reportingRecord => reportingRecord.entity.id === b.entity.id);

            if (bIndex === -1) {
              return -1;
            }

            return aIndex - bIndex;
          }) : campaignsList,
          aggregateFunnel: new ReportRecord(totals)
        });

        try {
          if (window.newrelic && campaignListData && campaignListData.campaigns) {
            window.newrelic.addPageAction('ads-all-campaigns-fetch-succeeded', {
              'ads-all-campaigns-fetch-succeeded-duration': window.performance.now() - now,
              'campaigns-fetched': campaignListData.campaigns.size,
              'ad-accounts-selected': payload.filters.get('adAccounts').size
            });
          } // eslint-disable-next-line

        } catch (e) {}

        return state.set(filters, campaignListData);
      }

    case Actions.CAMPAIGN_LIST_EARLY_REQUEST_FETCH_SUCCEEDED:
      {
        if (state.has(filters) || !payload) {
          return state;
        }

        const campaigns = payload.results.map(campaignData => ({
          entity: new ReportingCampaignRecord(campaignData),
          report: null,
          trackingStatus: null
        }));
        const campaignListData = CampaignListDataRecord({
          campaigns: List(campaigns.map(campaign => ReportingDataRecord(campaign))),
          aggregateFunnel: null
        });
        return state.set(filters, campaignListData);
      }

    case Actions.CAMPAIGN_LIST_STATE_INVALIDATE:
      {
        return state.delete(filters);
      }

    case Actions.CAMPAIGN_REPORTING_ENTITY_UPDATE_START:
      {
        if (!payload) {
          return state;
        }

        const {
          entityId,
          network,
          entityType,
          globalFilters,
          update: {
            status,
            name
          }
        } = payload;
        const activeFilter = fromGlobalFilters(globalFilters);

        if (entityType !== EntityTypes.CAMPAIGN || !state.has(activeFilter)) {
          return state;
        } // Update the state


        return state.updateIn([activeFilter, 'campaigns'], campaigns => {
          const index = campaigns.findIndex(({
            entity
          }) => entity.id === entityId && entity.network === network);
          return campaigns.updateIn([index, 'entity'], entity => {
            const mergedEntity = name ? entity.merge({
              name
            }) : entity;

            if (status) {
              return mergedEntity.set('status', getContactsStatus(status));
            } else {
              return mergedEntity;
            }
          });
        });
      }

    case Actions.CAMPAIGN_REPORTING_ENTITY_UPDATE_SUCCEEDED:
      {
        if (!payload) {
          return state;
        } // Delete the campaign only after success, so that the user gets some visual feedback.


        const {
          entityId,
          network,
          entityType,
          globalFilters,
          update: {
            status
          }
        } = payload;

        if (!status) {
          return state;
        }

        const activeFilter = fromGlobalFilters(globalFilters);
        const genericStatus = getContactsStatus(status); // get network-agnostic status

        if (entityType !== EntityTypes.CAMPAIGN || !state.has(activeFilter)) {
          return state;
        } else if (!activeFilter.statuses.has(genericStatus)) {
          return state.updateIn([activeFilter, 'campaigns'], campaigns => campaigns.filter(campaign => !(campaign.entity.id === entityId && campaign.entity.network === network)));
        }

        return state;
      }
    // The data we have isn't reliable now.
    // falls through so as to refresh the state

    case Actions.CAMPAIGN_LIST_RESET:
    case Actions.CAMPAIGN_REPORTING_ENTITY_UPDATE_FAILED:
      return ImmutableMap();

    default:
      return state;
  }
});